import request from "@/utils/request";
export function getTopics(params) {
  return request({
    url: "/posts/forum",
    method: "get",
    params
  });
}

export function getTopTopics(forumId) {
  return request({
    url: "/posts/top_topics",
    method: "get",
    params: { forumId },
  });
}

export function getPost(id, current) {
  return request({
    url: "/posts/thread",
    method: "get",
    params: { id, current },
  });
}
export function getPosts(params) {
  return request({
    url: "/posts/thread",
    method: "get",
    params,
  });
}
export function setBestAnswer(params) {
  return request({
    url: "/auth/replies/set_best_answer",
    method: "put",
    params,
  });
}


export function getReply(params) {
  return request({
    url: "/posts/reply",
    method: "get",
    params,
  });
}


export function getAd(params) {
  return request({
    url: "/posts/hot_article",
    method: "get",
    params,
  });
}
export function getProducts(params) {
  return request({
    url: "/posts/product_article",
    method: "get",
    params,
  });
}
export function getComments(params) {
  return request({
    url: "posts/comment_list",
    method: "get",
    params,
  });
}



export function getUserTopics(params) {
  return request({
    url: "/auth/user_topics",
    method: "get",
    params,
  });
}
export function getUserReplies(params) {
  return request({
    url: "/posts/user_replies",
    method: "get",
    params,
  });
}
export function getHomeData() {
  return request({
    url: "/posts/home",
    method: "get",
  });
}

export function search(params) {
  return request({
    url: "/pages/search",
    method: "get",
    params,
  });
}

export function saveReply(post) {
  return request({
    url: "/auth/replies/save",
    method: "post",
    data: post,
  });
}

export function saveTopic(post) {
  return request({
    url: "/auth/topics/save",
    method: "post",
    data: post,
  });
}

export function updateTopic(post) {
  return request({
    url: "/auth/admin/topics/update",
    method: "post",
    data: post,
  });
}
export function updateUserTopic(post) {
  return request({
    url: "/auth/topics/update",
    method: "post",
    data: post,
  });
}

export function updateReply(post) {
  return request({
    url: "/auth/admin/replies/update",
    method: "post",
    data: post,
  });
}

export function deleteTopicPost(id) {
  return request({
    url: "/auth/admin/topics/delete",
    method: "delete",
    params: { id },
  });
}

export function deleteReplyPost(id) {
  return request({
    url: "/auth/admin/replies/delete",
    method: "delete",
    params: { id },
  });
}

export function getPostById(id) {
  return request({
    url: "/posts/getById",
    method: "get",
    params: { id },
  });
}

export function postTop(id) {
  return request({
    url: "/auth/admin/topics/top",
    method: "post",
    params: { id },
  });
}

export function postCancelTop(id) {
  return request({
    url: "/auth/admin/topics/cancelTop",
    method: "post",
    params: { id },
  });
}

export function setSediment(id) {
  return request({
    url: "/auth/admin/topics/set_sediment",
    method: "post",
    params: { id },
  });
}

export function cancelSediment(id) {
  return request({
    url: "/auth/admin/topics/cancel_sediment",
    method: "post",
    params: { id },
  });
}

export function getSameTagPost(params) {
  return request({
    url: "/posts/same_tag_post",
    method: "get",
    params,
  });
}